import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Delete"
});
const _hoisted_1 = {
  class: "icon",
  width: "200px",
  height: "200.00px",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  d: "M160 256H96q-14.016 0-23.008-8.992T64 224t8.992-23.008T96 192h256V96q0-14.016 8.992-23.008T384 64h256q14.016 0 23.008 8.992T672 96v96h256q14.016 0 23.008 8.992T960 224t-8.992 23.008T928 256h-64v672q0 14.016-8.992 23.008T832 960H192q-14.016 0-23.008-8.992T160 928V256z m448-64V128h-192v64h192zM224 896h576V256H224v640z m192-128q-14.016 0-23.008-8.992T384 736V416q0-14.016 8.992-23.008T416 384t23.008 8.992T448 416v320q0 14.016-8.992 23.008T416 768z m192 0q-14.016 0-23.008-8.992T576 736V416q0-14.016 8.992-23.008T608 384t23.008 8.992T640 416v320q0 14.016-8.992 23.008T608 768z",
  fill: "currentColor"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var _delete = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "E:\\gitlab\\sgui-plus-icon\\packages\\vue\\src\\delete.vue"]]);

export { _delete as default };
